/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Menu, SelectIconButton } from '@neo4j-ndl/react';
import {
  ExploreIcon,
  HierarchyTwoIcon,
  SelectIcon,
} from '@neo4j-ndl/react/icons';
import { useRef, useState } from 'react';

const menuItems = [
  { leadingVisual: <ExploreIcon />, title: 'Force-based layout' },
  { leadingVisual: <HierarchyTwoIcon />, title: 'Hierarchical layout' },
];

const Component = () => {
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<number>();

  return (
    <div>
      <SelectIconButton
        description="Options"
        isOpen={isMenuOpen}
        onClick={() => setIsMenuOpen((old) => !old)}
        ref={anchorRef}
      >
        {selectedItem !== undefined ? (
          menuItems[selectedItem].leadingVisual
        ) : (
          <SelectIcon />
        )}
      </SelectIconButton>
      <Menu
        isOpen={isMenuOpen}
        anchorRef={anchorRef}
        onClose={() => setIsMenuOpen(false)}
      >
        {menuItems.map((item, index) => (
          <Menu.RadioItem
            key={index}
            isChecked={selectedItem === index}
            title={item.title}
            leadingVisual={item.leadingVisual}
            onClick={() => setSelectedItem(index)}
          />
        ))}
      </Menu>
    </div>
  );
};

export default Component;
